import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { Link, Redirect, withRouter } from 'react-router-dom';
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import InfoArea from 'components/InfoArea/InfoArea.jsx';
import productStyle from 'assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import HOCLoader from '../HOC/HOCLoader';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import ProgressiveImage from 'react-progressive-image';
import { Fade, DialogContent, Dialog } from '@material-ui/core';
import { NotificationManager } from 'react-notifications';
import Button from '@material-ui/core/Button';

import top1 from 'assets/images/services/20.jpg';
import top2 from 'assets/images/services/p1.jpg';
import top3 from 'assets/images/services/10.jpg';
import top4 from 'assets/images/services/ser5.jpg';
import NewServiceSuggestionDialog from '../Dialogs/NewServiceSuggestionDialog';
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category } from '@material-ui/icons';
import LoginDialog from '../Dialogs/LoginDialog';
import { cookies } from '../../utils/getToken';
import "./index.css";
let isMounted = false;
var addedTask = null

var selectedRandomBgColor = "rgba(0,120,255,0.2)"
var selectedRandomTextColor = "rgba(0,120,255,1)"
var currentColor = -1;
class TopCategories extends React.Component {
    p = 0;
    constructor() {
        super();
        this.state = {
            redirect: false, itemId: null,
            showServiceDialog: false,
            showSubCategoryDialog: false,
            serviceData: [],
            serviceDataAll: [],
            selectedServiceId: "",
            service_type: "",
            newServiceDialog: false,
            showBookButton: false,
            showLoginModal: false,
            showSuggestionButton: true,
            left: 0,
            randomTextColor: ['rgba(235,41,41,1)', 'rgba(31,187,84,1)', 'rgba(234,157,22,1)'],
            selectedRandomTextColor: "",
            randomBgColor: ['rgba(235,41,41,1)', 'rgba(31,187,84,1)', 'rgba(234,157,22,1)'],

            selectedRandomBgColor: "",
            categories1: [],
            categories2: [],
            headingTitle: '',
            headingTitleservice: '',
            percent: false,
            transitionClass: '',


        };

    }
    componentDidMount() {
        isMounted = true;
        this.getData();
    }
    getData = () => {
        if (isMounted) {
            this.props.allCategoryAction();
        }
    };
    getData = () => {
        if (isMounted) {
            this.props.masterCategoryAction();
        }
    };
    componentWillUnmount() {
        isMounted = false;
    }
    redirectCategory = (categoryId, service) => {
        console.log("kapilddd", categoryId, service)

        if (this.props.settings.constants.serviceAssignment == "user") {
            this.setState({ redirect: true, itemId: categoryId });
        } else {
            var tasksArray = service.map(taskItem => {
                taskItem.qty = 0
                return taskItem
            })
            this.setState({
                showServiceDialog: true,
                serviceData: tasksArray
            }, () => {
                console.log("servicesssssssss:::::::::22222:::::::", this.state.serviceData.services)
            })
        }

    };
    onBookNow = () => {
        console.log("onBookNow:::::", this.props.userData)
        const bookingPopupOption = this.props.userData.name ? true : false;

        if (bookingPopupOption) {
            addedTask = null;
            if (this.state.selectedServiceId === "") {
                NotificationManager.error(
                    "You haven't add any service",
                    'Oops!'
                );
            } else {
                this.setState({
                    selectedServiceId: "",
                    service_type: ""
                })
                this.props.history.push({
                    pathname: `/book/service/2912adarsh1245/`,
                    state: { serviceDataSource: this.state.serviceData }
                });
            }

        } else {
            console.log("Service ID AND Type::::", this.state.selectedServiceId, this.state.service_type)
            this.setState({
                showLoginModal: true,
                showServiceDialog: false,
            })

        }
    };

    renderLoading = index => {
        return (
            <div style={{ width: 200, margin: 10, height: 160 }} key={index}>
                <ContentLoader
                    height={160}
                    width={200}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    handleCloseServiceDialog = () => {
        this.setState({
            showServiceDialog: false,
            showBookButton: false
        })
    }

    handleCloseshowSubCategoryDialog = () => {
        this.setState({
            showSubCategoryDialog: false,

        })
    }

    popclick = (category, index) => {
        console.log('kapil', index, category[index].categories);
        this.state.headingTitle = category[index].categories[0].mastercategory.name;
        if (this.props.settings.constants.serviceAssignment == "user") {
            this.setState({ redirect: true, itemId: category });
        } else {
            var tasksArray = category[index].categories.map(taskItem => {
                // taskItem.qty = 0
                return taskItem
            })
            // var tasksArray=[];
            this.setState({
                // showServiceDialog: true,
                showSubCategoryDialog: true,
                serviceDataAll: tasksArray
            }, () => {
                console.log("servicesssssssss:::::::::22222:::::::", this.state.serviceData.services)
            })
        }
    }

    onBookNow = () => {
        console.log("onBookNow:::::", this.props.userData)
        const bookingPopupOption = this.props.userData.name ? true : false;

        if (bookingPopupOption) {
            addedTask = null;
            if (this.state.serviceData.length < 0) {
                NotificationManager.error(
                    "You haven't add any service",
                    'Oops!'
                );
            } else {
                /* this.setState({
                    selectedServiceId: "",
                    service_type: ""
                }) */
                this.props.history.push({
                    pathname: `/book/service/2912adarsh1245`,
                    state: { serviceDataSource: this.state.serviceData }
                });
            }


        } else {
            console.log("Service ID AND Type::::", this.state.selectedServiceId, this.state.service_type)
            this.setState({
                showLoginModal: true,
                showServiceDialog: false,
            })

        }
    };

    addServices = (index, serviceId, service_type) => {
        this.setState({
            selectedServiceId: serviceId,
            service_type: service_type
        }, () => { this.onBookNow() })
    }

    openNewServiceSuggestionDialog = () => {
    }
    handleCloseSuggestionDialog = () => {
        this.setState({
            newServiceDialog: false,
            showSuggestionButton: false, showBookButton: false,
        })
    }

    increaseQty(item, index) {
        console.log("Itemmmmmm :::", item)
        item.service_type == "Package" && "Hourly" ? item.qty += 1 : item.qty += 1;
        let updatedTask = [...this.state.serviceData];
        updatedTask[index] = item;
        const checkServiceData = updatedTask.filter(singleItem => singleItem.qty > 0);
        if (checkServiceData.length > 0) {
            this.setState({ serviceData: updatedTask, showBookButton: true });
        } else {
            this.setState({ serviceData: updatedTask, showBookButton: false });
        }
    }

    decreaseQty(item, index) {
        item.qty -= 1;
        let updatedTask = [...this.state.serviceData];
        updatedTask[index] = item;
        const checkServiceData = updatedTask.filter(singleItem => singleItem.qty > 0);
        if (checkServiceData.length > 0) {
            this.setState({ serviceData: updatedTask, showBookButton: true });
        } else {
            this.setState({ serviceData: updatedTask, showBookButton: false });
        }
    }

    handleCloseLoginModal = () => {
        console.log("Close Login modal:::")
        this.setState({
            showLoginModal: false,
            showBookButton: false,
        })
    }
    goLeft = () => {
        if (this.p < /* -this.props.categoryData.length * this.container.offsetWidth */ -1300) {
            return;
        }
        this.p += -this.container.offsetWidth - 50;
        this.setState({ left: this.p, percent: true, transitionClass: 'carousel-transition' });

        setTimeout(() => {
            this.setState({ transitionClass: '' });
        }, 1000);
    };
    goRight = () => {
        if (this.p === 0) {
            return;
        }
        this.p += this.container.offsetWidth + 50;
        this.setState({ left: this.p, transitionClass: 'carousel-transition' });

        setTimeout(() => {
            this.setState({ transitionClass: '' });
        }, 1000);
    };

    _getRandomColor() {
        let total = this.state.randomTextColor.length;
        if (currentColor == -1) {
            currentColor = Math.floor(Math.random() * total)
        } else {
            currentColor = (currentColor + 1) % total;
        }
        selectedRandomTextColor = this.state.randomTextColor[currentColor],
            selectedRandomBgColor = this.state.randomBgColor[currentColor]
    }

    getTopCategoriesForCarousel() {
        console.log("new all categoriesss>>>homescreen", this.props.categoryData);

        let allCategories = this.props.categoryData
            /* .slice(0, 4) */
            .map((category, index) => {
                if (category.key) {
                    this._getRandomColor()
                    return (
                        <div
                            className="customservicecard"
                            id="service_{{category.key}}"
                            onClick={() => {
                                cookies.set("x-auth-token", 'Guest', { path: "/" })
                                // this.props.history.push('/user/services', { categoryData: category })
                                this.props.history.push(`/user/services/${category.key}`, { categoryData: category });
                            }}
                            style={{
                                display: "block", margin: "15px 22px", transform: `translatex(${this.state.left}px)`,
                                transition: "0.3s"
                            }}
                            ref={el => (this.container = el)}>

                            <img className="responsive-service-img" style={{
                                verticalAlign: "middle", borderStyle: "none",
                                width: 110, height: 110, borderRadius: 150, marginLeft: 80, marginRight: 80
                            }}
                                src={category
                                    .image
                                    .medium}
                                alt={
                                    category.heading
                                } />
                            <h4 className="hovertext" style={{
                                paddingTop: 20, fontWeight: "500", marginBottom: ".5rem", fontSize: 20,
                                fontFamily: "Avenir", alignSelf: "center", textAlign: "center"
                            }}>{
                                    category.heading
                                }</h4>

                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <div style={{
                                    alignSelf: "center", background: "#ffffff", borderRadius: 5, marginTop: 10,
                                    textAlign: "center", width: 160, height: 40, display: "flex", alignItems: "center",
                                    justifyContent: "center", paddingTop: 10
                                }}>
                                    <p style={{ color: "#0078ff", fontSize: 18, fontWeight: "500" }}> Book now <ArrowForward /></p>
                                </div>
                            </div>
                        </div>

                    );
                } else {
                    return this.renderLoading(
                        index
                    );
                }
            }
            )
        let categories1 = [], categories2 = [];
        for (let i = 0; i < allCategories.length; i += 2) {
            categories1.push(allCategories[i])
            categories2.push(allCategories[i + 1]);
        }


        let arr = categories1.map((item, index) => {
            return (
                <div style={{ display: "flex", flexFlow: "column", alignItems: "center" }}>
                    {item}
                    {categories2[index]}
                </div>
            )
        })
        return arr;
    }

    render() {
        const { classes, settings } = this.props;
        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/category/services/`,
                state: { itemId: this.state.itemId }
            });
        }

        return (
            <div className="land-full land-packages" style={{ backgroundColor: this.props.colors.BACKGROUND.HEX, marginTop: "-50px" }}>

                <div className="side_img2">
                    <img
                        src={require('../../assets/images/rectangle6.png')}
                        alt={"img"
                        } />
                </div>
                <div className="container">
                    <div className="text-center col-12 com-title">
                        <h2>Browse All Service Categories</h2>
                        <p>Directly book with a Service Pro for the same day or a day in the future</p>
                    </div>
                </div>
                <div className="container2">

                    <div className="topCategoriesCarouselMobile">
                        <Carousel swipeable draggable responsive={{
                            desktop: {
                                breakpoint: { max: 4096, min: 721 },
                                items: 4,
                                slidesToSlide: 4
                            },
                            mobile: {
                                breakpoint: { max: 800, min: 0 },
                                items: 1
                            }
                        }}
                        >

                            {this.getTopCategoriesForCarousel()}
                        </Carousel>
                    </div>


                    <div className={`d-flex topCategoriesCarouselDesktop ${this.state.transitionClass}`}>
                        <div className="d-flex responsive-left-arrow-div"
                            onClick={() => {
                                this.goRight()
                                this.setState({
                                    p: this.state.p > 0 ? this.state.p + 350 : this.state.p < 0 ? this.state.p + 350 : 0
                                })
                            }}

                        >
                            <div className="responsive-left-arrow">
                                <ArrowBack style={{ color: "#ffffff" }} />
                            </div>
                        </div>


                        <div className="silder_icon">


                            <div ref={el => (this.container1 = el)} className="img-div"
                                style={{
                                    transform: `translateX(${this.state.left}px)`,
                                    transition: 'transform 0.5s ease'
                                }}
                            >
                                {this.props.categoryData
                                    /* .slice(0, 4) */
                                    .map((category, index) => {
                                        if (category.key) {
                                            this._getRandomColor()
                                            return (
                                                <div
                                                    className="customservicecard"
                                                    id={"service_" + category.key}
                                                    onClick={() => {
                                                        cookies.set("x-auth-token", 'Guest', { path: "/" })
                                                        // this.props.history.push('/user/services', { categoryData: category })
                                                        this.props.history.push(`/user/services/${category.key}`, { categoryData: category });
                                                    }}
                                                    style={{
                                                        transform: `translatex(${this.state.left}px)`,

                                                    }}
                                                    ref={el => (this.container = el)}
                                                >

                                                    <img className="responsive-service-img"
                                                        src={category
                                                            .image
                                                            .medium}
                                                        alt={
                                                            category.heading
                                                        } />
                                                    <h4 className="hovertext">{
                                                        category.heading
                                                    }</h4>

                                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                                        <div style={{
                                                            alignSelf: "center", background: "#ffffff", borderRadius: 5, marginTop: 10,
                                                            textAlign: "center", width: 160, height: 40, display: "flex", alignItems: "center",
                                                            justifyContent: "center", paddingTop: 10
                                                        }}>
                                                            <p style={{ color: "#0078ff", fontSize: 18, fontWeight: "500" }}> Services <ArrowForward /></p>
                                                        </div>
                                                    </div>

                                                </div>



                                            );
                                        } else {
                                            return this.renderLoading(
                                                index
                                            );
                                        }
                                    }
                                    )}
                            </div>
                        </div>
                        <div className="d-flex responsive-left-arrow-div" style={{ justifyContent: "center", alignContent: "center", alignItems: "center" }}
                            onClick={() => {
                                        /* this.setState({
                                            p: this.state.p - 350
                                        }) */this.goLeft()
                            }}>
                            <div className="responsive-left-arrow" style={{
                                width: 56, height: 56, borderRadius: 56, background: "#0078ff", textAlign: "center",
                                display: "flex", justifyContent: "center", alignItems: "center"
                            }}>
                                <ArrowForward style={{ color: "#ffffff" }} />
                            </div>
                        </div>

                        <div className="responsive-side-rectangle d-none" style={{ position: "absolute", left: 0, zIndex: -1 }}>
                            <img style={{
                                verticalAlign: "middle", borderStyle: "none", width: "auto", height: "40%"
                            }}
                                src={require('../../assets/images/rectangle6.png')}
                                alt={"img"
                                } />
                        </div>
                    </div>
                </div>

                <Dialog
                    fullWidth={true}
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="service-modal"
                    open={this.state.showServiceDialog}
                    onClose={this.handleCloseServiceDialog}
                    aria-labelledby="form-dialog-title"
                >


                    <div className="modal-header dir-pop-head">
                        <div className="heding1">
                            <h4>What would you like to do with {this.state.headingTitle} service</h4>
                        </div>
                        <Clear className="close_icon" style={{ alignSelf: "center", color: "#ffffff" }} onClick={() => {
                            this.handleCloseServiceDialog()
                        }} />

                    </div>

                    <div>
                        <DialogContent>
                            {this.state.serviceData.length > 0 && this.state.serviceData.map((item, index) => {

                                return (

                                    <div className="service-modal-li">
                                        <div className="row align-items-center" >
                                            <div className="col-md-8 text-left modal-list">
                                                {/* <h4 className="pb-2"> {item.categoryName}</h4> */}

                                                <h4>{item.heading}</h4>
                                                <p>{item.description}</p>
                                                <p>{item.service_type}</p>
                                                {item.service_type != "Hourly" ? <p className="color_text">${item.price}</p> : <p>{item.price}/hr</p>}

                                            </div>
                                            <div className="col-md-4 text-right d-flex" style={{ flexDirection: "row", borderRadius: 3 }}>


                                                {item.qty == 0 ?
                                                    <div className="col-md-12 d-flex " style={{ flexDirection: "row" }}>
                                                        <div className="col-md-8 justify-content-center d-flex">
                                                            {/* <p style={{ alignSelf: "center" }}>Add</p> */}
                                                        </div>
                                                        <div className="col-md-4 justify-content-center addplus d-flex" onClick={() => this.increaseQty(item, index)}
                                                            style={{ backgroundColor: this.props.colors.SECONDARY.HEX }}>
                                                            <Add style={{ alignSelf: "center", color: "white" }} />
                                                        </div>
                                                    </div> :

                                                    <div className="col-md-12 d-flex align-items-center" style={{ flexDirection: "row" }}>
                                                        <div className="col-md-4 justify-content-center addplus d-flex" onClick={() => this.decreaseQty(item, index)}
                                                            style={{ backgroundColor: this.props.colors.SECONDARY.HEX }}>
                                                            <Remove style={{ alignSelf: "center", color: "white" }} />
                                                        </div>
                                                        <div className="col-md-4 justify-content-center d-flex align-items-center">
                                                            <p style={{ alignSelf: "center" }}>{item.qty}</p>
                                                        </div>
                                                        <div className="col-md-4 justify-content-center addplus  d-flex" onClick={() => this.increaseQty(item, index)}
                                                            style={{ backgroundColor: this.props.colors.SECONDARY.HEX }}>
                                                            <Add style={{ alignSelf: "center", color: "white" }} />
                                                        </div>
                                                    </div>}

                                            </div>

                                        </div>
                                    </div>
                                )
                            })}
                            {this.state.serviceData.length == 0 ?
                                <div className="service-modal-li">
                                    <div className="row align-items-center">
                                        <div className="col-md-7 text-left modal-list">
                                            <h4>No service availabe in this category</h4>

                                        </div>
                                    </div>
                                </div> : null

                            }

                            {this.state.serviceData.length == 0 && this.state.showSuggestionButton &&
                                <div className="md-12 justify-content-center d-flex">
                                    <button type="button" className="custom-button"
                                        onClick={() => {
                                            this.openNewServiceSuggestionDialog()
                                        }}>NEW SERVICE SUGGESTION</button>
                                </div>}

                        </DialogContent>
                    </div>


                    {this.state.showBookButton && <button style={{
                        alignSelf: 'center', display: "inline-flex",
                        position: "unset", bottom: 10, justifyContent: "center",
                        backgroundColor: this.props.colors.SECONDARY.HEX, padding: 15, borderRadius: 8,
                        color: "#ffffff", borderWidth: 0, width: "90%", marginBottom: 15
                    }}
                        disabled={this.state.showBookButton ? false : true}
                        onClick={this.onBookNow}
                    >BOOK NOW</button>}

                    {this.state.newServiceDialog &&
                        <NewServiceSuggestionDialog
                            closeDialog={this.handleCloseSuggestionDialog}
                        />}

                </Dialog>




                <Dialog
                    fullWidth={true}
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="service-modal"
                    open={this.state.showSubCategoryDialog}
                    onClose={this.handleCloseshowSubCategoryDialog}
                    aria-labelledby="form-dialog-title"

                >
                    <div>

                        <div className="modal-header dir-pop-head">
                            <div className="heding1">
                                <h4>


                                    {this.state.headingTitle} Service

                                </h4>
                            </div>
                            <Clear className="close_icon" style={{ alignSelf: "center", color: "#ffffff" }} onClick={() => {
                                this.handleCloseshowSubCategoryDialog()
                            }} />

                        </div>

                    </div>

                    <div>
                        <DialogContent className="model">
                            {/* serviceDataAll */}

                            {this.state.serviceDataAll.length > 0 && this.state.serviceDataAll.map((item, index) => {

                                return (
                                    <div className="service-modal-li">
                                        <div className="row align-items-center">
                                            <div className="col-md-12 text-left modal-list d-flex justify-content-between">
                                                <h4 className="d-flex align-self-center">{item.heading}</h4>
                                                <button id={'select_' + item.key}
                                                    style={{
                                                        bottom: 10, justifyContent: "center",
                                                        backgroundColor: this.props.colors.SECONDARY.HEX, padding: 15, borderRadius: 8,
                                                        color: "#ffffff", borderWidth: 0,
                                                    }}
                                                    onClick={() => this.redirectCategory(item.mastercategory_id, item.services)}

                                                >Select</button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}

                        </DialogContent>
                    </div>

                    {this.state.newServiceDialog &&
                        <NewServiceSuggestionDialog
                            closeDialog={this.handleCloseshowSubCategoryDialog}
                        />}

                </Dialog>



                {this.state.showLoginModal &&
                    <LoginDialog
                        showLoginModal={this.state.showLoginModal}
                        selectedServiceId={this.state.selectedServiceId}
                        service_type={this.state.service_type}
                        closeLoginModal={this.handleCloseLoginModal}
                        serviceDataSource={this.state.serviceData}
                    />}
            </div>


        );
    }
}

const mapStateToProps = ({ settings, auth }) => {
    return {
        settings: settings,
        userData: auth.userData,
        colors: settings.colors
    };
};

const composedComponent = compose(
    withStyles(productStyle),
    connect(mapStateToProps, actions)
);
export default composedComponent(withRouter(TopCategories));



// WEBPACK FOOTER //
// ./src/components/Category/TopCategories.js